<div class="main">
  <div>{{ 'Projekt:' | uppercase }}</div>
  <mat-card appearance="filled">
    <mat-card-content>
      <mat-form-field [style.width.%]="100">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Sök</mat-label>
        <input [(ngModel)]="searchQuery" matInput>
      </mat-form-field>
      @if (userService.adminUser()) {
        <button (click)="newProject()" class="add-project-button"
                matButton="filled">
          <mat-icon>add_2</mat-icon>
          Skapa nytt projekt
        </button>
      }
      <mat-divider/>
      <smt-project-buttons
        [userId]="userService.user().id"
        [projects]="filteredProjects()"
      />
    </mat-card-content>
  </mat-card>
</div>
